export const NUMBER_REGEX = /[\d,.]+/g;
export const PASSPORT_SERIES_REGEX = /\d{4}\s\d{6}/gi;
export const PASSPORT_CODE_REGEX = /^\d{3}-\d{3}$/gi;
